/**
 * Creates a promise "meta object" with reference to the promise and
 * the resolve function so that this can be resolved externally later.
 *
 * @return {object}
 */
function createManualPromise() {
    let resolveFunc
    const promise = new Promise(resolve => {
        resolveFunc = resolve
    })

    return {
        promise,
        resolve: resolveFunc
    }
}

export {createManualPromise}
